module.exports = __webpack_public_path__ + "img/order-step4-c.065fc3c3.png";